<template>
  <v-card light flat min-width="150">
    <v-row class="fill-height" v-if="message">
      <v-card-title>
        <div
          class="title px-2"
          v-if="message.action"
        >{{message.action.name}}</div>
      </v-card-title>
      <v-card-subtitle v-if="message.title">
        <div class="d-flex">
          <img v-if="message.icon" class="mr-2" height="25" :src="message.icon" />
          <div>{{message.title}}</div>
          </div>
      </v-card-subtitle>
    </v-row>

    <v-card-text class="my-0 py-0" v-if="message">
      <span class="grey--text">{{message.created_at | date_time}}</span>
      <p>{{message.action.description}}</p>
    </v-card-text>
    <v-card-actions class="mt-0">
      <v-btn text color="grey darken-4" @click="action(message)">{{actionLabel}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
  props: {
    message: {
      type: Object,
      default: () => {
        return {};
      },
    },
    action: Function,
    actionLabel: {
      type: String,
      default: 'Show'
    }
  },
};
</script>

<style lang="scss" scoped>
</style>